import { ReactNode, useState } from "react";
import styles from "./Callout.module.css";

type CalloutProps = {
  children: ReactNode;
  icon: ReactNode;
  variant: "default" | "alert" | "notice";
};

export function Callout({ children, variant = "default", icon }: CalloutProps) {
  const [dismissed, setDismissed] = useState(false);

  return (
    <div
      className={styles.calloutRoot}
      data-variant={variant}
      data-dismissed={dismissed}
      onClick={() => setDismissed(true)}
    >
      {icon}
      {children}
    </div>
  );
}
